import React from "react";
import ReactMarkdown from "react-markdown";
import type { Components } from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import "./styles.scss";

export interface MarkdownContentProps {
  content: string;
  className?: string;
}

/**
 * El CMS entrega `contenido` como markdown (richtext de Strapi), no HTML.
 * `rehype-sanitize` queda como segunda barrera: react-markdown ya descarta el
 * HTML crudo, pero así el render sigue siendo seguro si alguien agrega rehype-raw.
 */
const components: Components = {
  a: ({ children, href, title }) => (
    <a href={href} title={title} target="_blank" rel="noreferrer">
      {children}
    </a>
  ),
  img: ({ src, alt, title }) => (
    <img src={src} alt={alt || ""} title={title} className="img-fluid" />
  ),
  table: ({ children }) => (
    <div className="table-responsive">
      <table className="table table-striped">{children}</table>
    </div>
  ),
};

const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  className,
}) => {
  if (!content) {
    return null;
  }

  return (
    <div className={`markdown-content ${className || ""}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={components}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;
